export const MUTATION_KEYS = {
    notifications_seen: 'notifications-seen'
}

export const QUERY_KEYS = {
    notificationsHistory: 'notifications-history',
    notificationUnreadCount: 'notification-unread-count'
}
